export const SET_CATEGORY_FILTER = 'SET_CATEGORY_FILTER'
export const REFRESH_CATEGORY_FILTER = 'REFRESH_CATEGORY_FILTER'
